import clsx from 'clsx';
import React from 'react';

function ErrorMessage({ variant = 'error', className, children }) {
  return (
    <div
      className={clsx(
        'my-2',
        {
          'text-red-500': variant === 'error',
          'text-gray-800': variant === 'notice',
        },
        className,
      )}
    >
      {children}
    </div>
  );
}

export default ErrorMessage;
